import type { ApplicationInsights } from "@microsoft/applicationinsights-web";

let instance = null;
let loadingProcess = null;

const loadModule = async () => {
  const [applicationInsightsModule, reactPluginModule] = await Promise.all([
    import("@microsoft/applicationinsights-web"),
    import("@microsoft/applicationinsights-react-js"),
  ]);

  const defaultBrowserHistory = {
    url: "/",
    location: { pathname: "" },
    listen: () => {},
  };

  let browserHistory = defaultBrowserHistory;
  if (typeof window !== "undefined") {
    browserHistory = { ...browserHistory, ...window.history };
    browserHistory.location.pathname = browserHistory?.url;
  }

  const reactPlugin = new reactPluginModule.ReactPlugin();
  const appInsights: ApplicationInsights =
    new applicationInsightsModule.ApplicationInsights({
      config: {
        instrumentationKey: process.env.NEXT_PUBLIC_APP_INSIGHTS_KEY,
        maxBatchSizeInBytes: 10000,
        maxBatchInterval: 15000,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
        },
      },
    });
  return appInsights;
};

export const getTracking = async () => {
  if (instance) {
    return instance;
  }

  if (loadingProcess) {
    return loadingProcess;
  }

  loadingProcess = new Promise((resolve) => {
    loadModule().then((appInsights) => {
      instance = appInsights;
      if (typeof window !== "undefined") {
        appInsights.loadAppInsights();
      }
      resolve(appInsights);
    });
  });

  return loadingProcess;
};
